module.exports = __webpack_public_path__ + "img/rear-1.430265ec.jpg";